import {Component} from "@angular/core";
import {ILotteryRewardGroupsItem} from "../../definitions";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {FactoryService} from "../../services/factory.service";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {IDocument} from "../../interfaces/document.definition";


@Component({
  templateUrl: "./levels.attributes-page.component.html"
})
export class LevelsAttributesPageComponent {
  UI_TEXTS = UI_TEXTS;
  VALUE_TYPE = VALUE_TYPE;

  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Аттрибуты - Уровни");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.LEVEL)
    .setListLabels("максимум опыта", "%/maxXp%")
    .setSearchParams(paramsHelper.search()
      .addNumberParam("id"));


  document: IDocument;
  selected: ILotteryRewardGroupsItem;


  constructor(private busService: BusService,
              private factoryService: FactoryService) {
    this.busService.onDocumentUpdated
      .subscribe(
        e => {
          this.clear();
          this.document = e.document;
        });
  }


  onSelected(selectedItem: ILotteryRewardGroupsItem) {
    this.clear();
    this.selected = selectedItem;
  }


  onRemoved(removedItem: ILotteryRewardGroupsItem): void {
    if (removedItem === this.selected) {
      this.clear();
    }
  }


  addRewardGroup(): void {
    this.factoryService.addLotteryRewardGroupIntoLevel(this.document);
  }


  addRewardItem(): void {
    this.factoryService.addRewardItemIntoLevelLotteryGroup(this.selected);
  }


  private clear() {
    this.selected = null;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/attributes/levels.attributes-page.component.ts